const tbOther = {
  table: 'tb_other',
  idKey: 'id',

  attrs: [
    'heading',
    'text',
    'creationDate',
    'lastModifiedDate',
    'deleted'
  ],

  relationships: [ 
    {
      type: 'companies',
      key: 'company',
    },   
    {
      type: 'toolboxes',
      key: 'toolbox',
    },
    {
      type: 'doc-info',
      key: 'photo',
    }
  ],
}

export default tbOther